import React, { useState, useEffect, useRef } from 'react';

import FilmScoreData from '../Data/FilmScoreData';
import MusicPlayer from './MusicPlayer';

import Cross from '../../Images/x.svg';
import video from '../../Images/video.svg';
import home from '../../Images/home.svg';

const ProjectModal = ({modal,setModal}) => {
	const [ playing, setPlaying ] = useState('');
	const [ topCount, setTopCount ] = useState(0);

	// Dropdown stuff
		const node = useRef();
		useEffect(()=>{
			function handleClick(e) {
				if(node.current) {
					if(node.current.contains(e.target)){
					} else {
						setModal('');
						setPlaying('');
						setTopCount(0);
					}
				}
			}
			document.addEventListener('mousedown', handleClick, false);
			return () => {
				document.removeEventListener('mousedown', handleClick, false);
			}
		},[setModal]);


	function closeModal() {
		setModal('');
		setPlaying('');
		setTopCount(0);
	}

	function playPressed(e) {
		const audio = document.getElementById(e);
		if(playing.id === e){
			if(playing.play === true){
				audio.pause();
				setPlaying({id:e,play:false});
			} else {
				audio.play();
				setPlaying({id:e,play:true});
			}
		} else {
			// stop previously playing song if playing
			if(playing.play === true){
				const audio_old = document.getElementById(playing.id);
				audio_old.pause();
			}
			audio.play();
			setPlaying({id:e,play:true});
		}
	}


	function songLoop(selected) {
		let arr = [];
		for(let i = 0; i < selected.songs.length; i++){
			arr.push(
				<div key={i}>
					<MusicPlayer song={selected.songs[i]} id={modal+i} playPressed={playPressed} playing={playing} width={600} />
				</div>
			)
		}
		return arr
	}

	function topHeader(selected) {
		let arr = [];
		let arr2 = [];
		arr.push(<div key={'1e'} className='flexCenter'><img src={selected.banner} alt='banner' style={{height:318}} /></div>);
		let opacity = 0.4;
		if(topCount === 0) opacity = 1;
		arr2.push(<div key={'1d'} style={{margin:3,background:'rgb(70,70,70)',opacity:opacity}} className='pointer flexCenter circle2'
				onClick={()=>{setTopCount(0)}}>
			<img src={home} alt='home' className='iconSize2' />
		</div>)
		for(let i = 0; i < selected.clips.length; i++){
			arr.push(
				<div key={i}>
					<video loop={false} autoPlay={false} width={'100%'} controls={true}
							// ref={vidRef}
							>
						<source src={selected.clips[i]} type="video/mp4" />
					</video>
				</div>
			)
			opacity = 0.4;
			if(topCount === i+1) opacity = 1;
			arr2.push(<div key={i} style={{margin:3,background:'rgb(70,70,70)',opacity:opacity}} className='pointer flexCenter circle2'
					onClick={()=>{setTopCount(i+1)}}>
				<img src={video} alt='video' className='iconSize2' />
			</div>)
		}
		if(arr.length > 1){
			// make a navigator
			return(
				<div>
					<div style={{width:600,height:318,overflow:'hidden'}}>{arr[topCount]}</div>
					<div className='flexCenter'>
						<div className='absolute flexCenter' style={{marginTop:-60}}>{arr2}</div>
					</div>
				</div>
			)
		}
		return <div style={{width:600,height:318,overflow:'hidden'}}>{arr[topCount]}</div>
	}

	if(modal === '') return null
	const selected = FilmScoreData[modal];
	return(
		<div className='modalBack flexCenter'>
			<div className='modal' ref={node}>
				<div className='flexRight relative' style={{backgroundImage:'linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0))',height:50,marginBottom:-50,zIndex:200}}>
					<img src={Cross} alt='cross' style={{height:24,margin:10}} className='pointer absolute' onClick={closeModal} />
				</div>
				<div className='flexCenter' style={{background:'black'}}>
					{topHeader(selected)}
				</div>
				<div style={{padding:10}}>
					<div className='subHeading'>{selected.name}</div>
					<div className='flexLeft mainText' style={{width:600-20}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
					<div className='borderBottom' style={{marginTop:10}}></div>
					{songLoop(selected)}
				</div>
			</div>
		</div>
	)
}

export default ProjectModal;